import { HeightPlacementRestrictionValidation } from "@inter-ikea-storagetwo/range/dist/validations/HeightPlacementRestrictionValidation";
import { CabinetPlacementRestrictionValidation } from "./CabinetPlacementRestrictionValidation";
import { ConnectionHoleRestrictionValidation } from "@inter-ikea-storagetwo/range/dist/validations/ConnectionHoleRestrictionValidation";
import { OrganizerLimitValidation } from "@inter-ikea-storagetwo/range/dist/validations/organizerLimitValidation";
import { HeightRestrictionValidation } from "@inter-ikea-storagetwo/range/dist/validations/HeightRestrictionValidation";
export const validations = {
    HeightPlacementRestrictionValidation: () => new HeightPlacementRestrictionValidation(),
    CabinetPlacementRestrictionValidation: () => new CabinetPlacementRestrictionValidation(),
    ConnectionHoleRestrictionValidation: () => new ConnectionHoleRestrictionValidation(),
    OrganizerLimitValidation: () => new OrganizerLimitValidation(),
    HeightRestrictionValidation: () => new HeightRestrictionValidation(),
};
